import { statsApi } from '@/api/index';

const language = 'id-id'

const formatDate = function (gmtDate) {
    let date = new Date(gmtDate.replace(/-/g, '/')).getTime(); // 获取UTC时间戳
    let diffMin = new Date().getTimezoneOffset(); // 返回UTC时间和当前计算机上的时间之间相差的分钟数。utc-当地=差分钟数;
    let localDate = new Date(date - diffMin * 60 * 1000); // 获取当地时间
    let localMonth = dateToDubble(localDate.getMonth() + 1);
    let localTimeDetail = ('' + localDate).split(' ');
    let localMdHm = localMonth + '-' + localTimeDetail[2] + ' ' + localTimeDetail[4].split(':')[0] + ':' + localTimeDetail[4].split(':')[1];
    return {
        finalTime_md_hm: localMdHm
    };
};
const dateToDubble = function (str) {
    if (str < 10) {
        return '0' + str;
    } else {
        return str;
    }
};
const putLocalTimeToData = function (dataToTransfer) {
    if (dataToTransfer) {
        dataToTransfer.forEach(function (elem, index) {
            if (elem.template === 'team_point_ranking_match') {
                elem.content.data.forEach(function (e, i) {
                    if (e.start_play) {
                        let dateTime = e.start_play;
                        e.finalIneedTime = formatDate(dateTime);
                    }
                });
            } else if (elem.template === 'team_point_ranking_aggregate') {
                elem.content.data.forEach(function (e, i) {
                    if (e.match1.start_play) {
                        let dateTime = e.match1.start_play;
                        e.match1.finalIneedTime = formatDate(dateTime);
                    }
                    if (e.match2.start_play) {
                        let dateTime1 = e.match2.start_play;
                        e.match2.finalIneedTime = formatDate(dateTime1);
                    }
                });
            }
        });
    }
};

const state = {
    noDataMode: false,
    loadingShow: true,
    currentListData: null, // 当前选中tab下的所有数据
    currentTab: ''
};
const getters = {
    getStatsNoDataMode: state => state.noDataMode,
    getStatsLoadingShow: state => state.loadingShow,
    getCurrentStatsListData: state => state.currentListData// 当前选中tab下的所有数据
};

const actions = {
    statsListApi ({ commit, state }, { urlApi, thirdTitChoose }) {
        const _url = `${urlApi}&language=${language}` || '';

        state.loadingShow = true;

        return statsApi.getStatsList(_url).then(response => {
            if (thirdTitChoose === 'Gol' || thirdTitChoose === 'Umpan gol') {
                commit('getGoalsStatsList', response);
                return;
            }
            if (thirdTitChoose === 'Perlengkapan') {
                commit('getFixturesStatsList', response);
                return;
            }

            commit('getTableStatsList', response);
        }, error => {
            console.log('error', error);
            commit('getStatsListFail');
        });
    }
};

const mutations = {
    getTableStatsList (state, params) {
        state.loadingShow = false;
        state.currentListData = [];

        if (params.content && params.content.rounds && params.content.rounds.length) {
            state.noDataMode = false;
            putLocalTimeToData(params.content.rounds);
            state.currentListData = params.content.rounds;
            return;
        }
        state.noDataMode = true;
    },

    getGoalsStatsList (state, params) {
        state.loadingShow = false;
        state.currentListData = {};

        if (params.content && params.content.data && params.content.data.length) {
            state.noDataMode = false;
            state.currentListData = params.content;
            return;
        }
        state.noDataMode = true;
    },

    getFixturesStatsList (state, params) {
        state.loadingShow = false;
        state.currentListData = {};
        if (params.content && params.content.matches && params.content.matches.length) {
            state.noDataMode = false;
            state.currentListData = params.content;
            return;
        }
        state.noDataMode = true;
    },
    getStatsListFail (state) {
        state.loadingShow = false;
        state.noDataMode = true;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/statsListStore.js